export class CommonFragments {
  public static readonly disclaimerFragment = `
    disclaimers {
      code
      text
      rank
      footer
      superscriptPosition
    }
  `;

  public static readonly keyFactsFragment = `
    keyFacts {
      title
      value
      valueFormat
      tooltip
      asOfDate
      rank
      subtitle
      disclaimerCode
      subContent
    }
  `;

  public static readonly teamMemberFragment = `
    name
    jobTitle
    yearsOfExperience
    yearsAtCompany
    bioKey
    imageSource
  `;

  public static readonly literaturesFragment = `
    literatures {
      locked
      name
      url
    }
  `;
}
